export const TEST_ENTRIES = [
  {
    id: 10560,
    created_at: '2024-07-19 07:52:21.459625+00',
    request_id: 20,
    year: '1999',
    month: '1',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '2317680',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '579420',
      },
      {
        id: '3',
        key: 'Dr. Co',
        value: '156600',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '3053700',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10561,
    created_at: '2024-07-19 07:53:06.507898+00',
    request_id: 20,
    year: '1999',
    month: '2',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '2505600',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '626400',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '3132000',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10564,
    created_at: '2024-07-19 07:54:25.088053+00',
    request_id: 20,
    year: '1999',
    month: '3',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '2516530',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '629133',
      },
      {
        id: '3',
        key: 'Prime',
        value: '220000',
      },
      {
        id: '4',
        key: 'Dr. Co',
        value: '299587',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '3665250',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10565,
    created_at: '2024-07-19 07:55:18.552614+00',
    request_id: 20,
    year: '1999',
    month: '4',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '2756200',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '689050',
      },
      {
        id: '3',
        key: 'Prime',
        value: '300000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '3745250',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10567,
    created_at: '2024-07-19 07:56:08.044809+00',
    request_id: 20,
    year: '1999',
    month: '5',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3341700',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '835425',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4177125',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10568,
    created_at: '2024-07-19 07:56:49.995799+00',
    request_id: 20,
    year: '1999',
    month: '6',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3341700',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '835425',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4177125',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10575,
    created_at: '2024-07-19 08:03:14.881853+00',
    request_id: 20,
    year: '1999',
    month: '7',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3341700',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '835425',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4177125',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10576,
    created_at: '2024-07-19 08:04:34.24985+00',
    request_id: 20,
    year: '1999',
    month: '8',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '759477',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '189869',
      },
      {
        id: '3',
        key: 'Prime',
        value: '800000',
      },
      {
        id: '4',
        key: 'Dr. Co',
        value: '3227778',
      },
      {
        id: '5',
        key: 'Prim Co',
        value: '600000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '5577124',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10577,
    created_at: '2024-07-19 08:05:19.053215+00',
    request_id: 20,
    year: '1999',
    month: '9',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3322713',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '830678',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4153391',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10578,
    created_at: '2024-07-19 08:06:33.572968+00',
    request_id: 20,
    year: '1999',
    month: '10',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3653588',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '913397',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4566985',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10579,
    created_at: '2024-07-19 08:07:41.046216+00',
    request_id: 20,
    year: '1999',
    month: '11',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '3062209',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '765552',
      },
      {
        id: '3',
        key: 'Dr. Co',
        value: '850614',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4678375',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10580,
    created_at: '2024-07-19 08:08:39.305253+00',
    request_id: 20,
    year: '1999',
    month: '12',
    properties: [
      {
        id: '1',
        key: 'Lei/Reg',
        value: '2721964',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '680491',
      },
      {
        id: '3',
        key: 'Dr. Co',
        value: '1275920',
      },
      {
        id: '4',
        key: 'Prime',
        value: '1235675',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '5914050',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10544,
    created_at: '2024-07-19 07:28:11.341939+00',
    request_id: 20,
    year: '2000',
    month: '1',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3542198',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '885550',
      },
      {
        id: '3',
        key: 'Drept concediu',
        value: '222780',
      },
      {
        id: '4',
        key: 'Premiere',
        value: '300000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4950528',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10546,
    created_at: '2024-07-19 07:30:05.553871+00',
    request_id: 20,
    year: '2000',
    month: '2',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3564476',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '891119',
      },
      {
        id: '4',
        key: 'Premiere',
        value: '300000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4755595',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10547,
    created_at: '2024-07-19 07:31:29.009826+00',
    request_id: 20,
    year: '2000',
    month: '3',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3742700',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '935675',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4678375',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10548,
    created_at: '2024-07-19 07:32:26.848037+00',
    request_id: 20,
    year: '2000',
    month: '4',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3742700',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '935675',
      },
      {
        id: '3',
        key: 'Premiere',
        value: '935675',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '5614050',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10549,
    created_at: '2024-07-19 07:33:28.587753+00',
    request_id: 20,
    year: '2000',
    month: '5',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3555571',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '888893',
      },
      {
        id: '3',
        key: 'Drept concediu prima vacanta ',
        value: '1777786',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '6222250',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10550,
    created_at: '2024-07-19 07:36:10.549227+00',
    request_id: 20,
    year: '2000',
    month: '6',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '3846482',
      },
      {
        id: '2',
        key: 'Spor vechime ',
        value: '961620',
      },
      {
        id: '3',
        key: 'Drept concediu prima vacanta ',
        value: '2762636',
      },
      {
        id: '4',
        key: 'Ore de noapte',
        value: '395961',
      },
      {
        id: '5',
        key: 'Premiere',
        value: '400000',
      },
      {
        id: '6',
        key: 'Ore suplimentare ',
        value: '1018186',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '9384885',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10574,
    created_at: '2024-07-19 08:02:00.439145+00',
    request_id: 20,
    year: '2000',
    month: '7',
    properties: [
      {
        id: '1',
        key: 'Indemnizatie din asigurari sociale  ',
        value: '9955000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '9955000',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10551,
    created_at: '2024-07-19 07:39:50.654831+00',
    request_id: 20,
    year: '2000',
    month: '8',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '905055',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '905055',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10553,
    created_at: '2024-07-19 07:40:25.571978+00',
    request_id: 20,
    year: '2000',
    month: '9',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '4977800',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '4977800',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10554,
    created_at: '2024-07-19 07:41:02.345114+00',
    request_id: 20,
    year: '2000',
    month: '10',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '5724500',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '5724500',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10555,
    created_at: '2024-07-19 07:41:55.389559+00',
    request_id: 20,
    year: '2000',
    month: '11',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '5940000',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '5940000',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
  {
    id: 10556,
    request_id: 20,
    year: '2000',
    month: '12',
    properties: [
      {
        id: '1',
        key: 'Salariu pentru program normal de lucru',
        value: '5051250',
      },
      {
        id: '2',
        key: 'Premieri',
        value: '1515302',
      },
      {
        id: '0',
        key: 'Total venit lunar realizat',
        value: '6566552',
      },
    ],
    created_by: 'ef0a2f80-7edf-4fc4-8f11-5cfbeb8f2f46',
    details: null,
  },
];
